import { isEqual } from 'lodash'
import moment from 'moment'

import featureToggles from './featureToggles'
import { getStateValue } from './states'

const classNameMap = {
    visa: 'visa',
    'american express': 'american-express',
    americanexpress: 'american-express',
    mastercard: 'mastercard',
    'debit-iterac': 'iterac',
    debit: 'debit',
    amex: 'american-express',
}

const creditCardShortCodes = {
    visa: 'VISA',
    'american express': 'AM',
    americanexpress: 'AM',
    mastercard: 'MC',
    'debit-iterac': 'IR',
    debit: 'DE',
    amex: 'AM',
}

export const getCreditCardShortCode = cardType =>
    cardType && creditCardShortCodes[cardType.toLowerCase()] ? creditCardShortCodes[cardType.toLowerCase()] : 'card'

export const getCreditCardType = cardType =>
    cardType && classNameMap[cardType.toLowerCase()] ? classNameMap[cardType.toLowerCase()] : 'card'

export const getPaymentType = paymentType =>
    paymentType === 'phone' || paymentType === 'cash' ? paymentType : getCreditCardType(paymentType)

export const getCreditCardNumberPreview = ({ nickName, cardLast4, expDate }) =>
    `${nickName} ${cardLast4 ? `**** ${cardLast4.slice(-4)}` : ''} ${expDate ? expDate.match(/.{1,2}/g).join('/') : ''}`

export const getPadNumberPreview = ({ achAccountNumber }) =>
    `PAD **** ${achAccountNumber && achAccountNumber.slice(-4)}`

export const objectsEqual = (objects, exclusions = []) => {
    const updatedObjects = objects.map(obj => {
        exclusions.forEach(exl => {
            if (obj && exl in obj) {
                delete obj[exl]
            }
        })

        return obj
    })

    return updatedObjects.reduce((a, b) => isEqual(a, b))
}

export const isAddressFilled = (address = {}) => {
    const { address1, postalCode, city, country, state, district, streetNumber } = address || {}

    const requiredFields = featureToggles.caPurchaseFlow
        ? [address1, postalCode, city, country, state]
        : featureToggles.isColumbia
          ? [address1, postalCode, city, country, district, streetNumber]
          : [address1, postalCode, city, country, state, district, streetNumber]

    return !checkSomeValueNotExists(requiredFields)
}

export const checkSomeValueNotExists = array => array.some(value => !value)

export const formatAddress = (address = {}) => {
    const { address1, address2, postalCode, city, country, state } = address
    const stateName = getStateValue(country)(state)

    const stateNameFormated = stateName ? `${stateName.label}, ` : ''
    const address2Formated = address2 ? `${address2}, ` : ''

    return `${address1}, ${address2Formated}${postalCode}, ${city}, ${stateNameFormated}${country}`
}

export const isExternalUrl = (url = '') => /^https?:\/\/.+$/.test(url)

export const formatLocale = locale => locale.replace('-', '_').replace(/_.*$/, match => match.toUpperCase())

export const firstDayOfTheMonth = () => moment().add(1, 'months').startOf('month')

export const capitalizeFirstLetter = string => string?.charAt(0).toUpperCase() + string.slice(1).toLowerCase()

export const getCurrentComponent = (routeComponents, history) => {
    const currentRoute = history.location.pathname.split('/').splice(2, 2).join('/')
    return routeComponents.find(component => component.key === currentRoute)
}

export const getPlateRegex = () => {
    if (featureToggles.brNeoPurchaseFlow) {
        return /^(?:[A-Za-z]{3}[0-9][A-Za-z][0-9]{2}|[A-Za-z]{3}[0-9]{4})$/
    }

    if (featureToggles.isColumbia) {
        // License plate formats: ABC123 / ABC12D /AB123C
        return /^(?:[A-Za-z]{3}\d{3}|[A-Za-z]{3}\d{2}[A-Za-z]{1}|[A-Za-z]{2}\d{3}[A-Za-z]{1})$/
    }

    return /^[A-Za-z0-9]{1,10}$/
}
